<template>
  <div :id="idMap">
    <div class="google-map" ref="googleMap"></div>
    <input
      id="idLugaresAdministracionDireccion"
      class="controls"
      type="text"
      placeholder="Búsqueda..."
    />

    <template v-if="Boolean(map)">
      <BaseMeasureDistance :googleMap="$refs.googleMap" />
    </template>

    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot :google="google" :map="map" />
    </template>
  </div>
</template>

<script>
import store from '@/store'
import { MapHelpers } from '@/helpers/mainExports'
import { i18n } from '@leapsight/portal'
import BaseMeasureDistance from '@/components/geofences/map/ContextualMenuOnMap/BaseContextualMenuOnMap.vue'
export default {
  components: { BaseMeasureDistance },
  props: {
    mapConfig: Object,
    idMap: {
      type: String
    }
  },

  data() {
    return {
      google: null,
      googleMap: null,
      map: null,
      placeholder: i18n.t('fleet_management.geofences.map.labels.search_input'),
      marker: null,
      customMarker: null,
      geocoder: null,
      geocodeResult: null
    }
  },
  mounted() {
    this.google = window.google
    this.initializeMap()
    this.geocoder = new google.maps.Geocoder()

    this.$root.$on('hideMarker', this.hideMarker)
    this.$root.$on('marker-icon', this.updateCustomMarker)
  },
  beforeDestroy() {
    this.$root.$off('hideMarker', this.hideMarker)
    this.$root.$off('marker-icon', this.updateCustomMarker)
  },
  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap
      this.map = new google.maps.Map(mapContainer, this.mapConfig)
      this.$store.state.map = this.map

      if (!this.geocoder) {
        this.geocoder = new google.maps.Geocoder()
      }

      // Obtener latitud y longitud al clickear en el mapa
      this.map.addListener('click', e => {
        const lat = e.latLng.lat()
        const lng = e.latLng.lng()

        this.$store.commit('pointOfInterest/setPointOfInterestGeoCoordinates', {
          lat,
          lng
        })

        if (!this.marker) {
          this.marker = new google.maps.Marker({
            position: e.latLng,
            map: this.map,
            animation: google.maps.Animation.DROP
          })
        } else {
          this.marker.setPosition(e.latLng)
        }
        this.marker.setVisible(true)

        this.geocodeLatLng(lat, lng)
      })

      // Create the search box and link it to the UI element.
      const input = document.getElementById('idLugaresAdministracionDireccion')
      const searchBox = new google.maps.places.SearchBox(input)
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

      this.marker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.DROP,
        visible: false
      })

      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener('bounds_changed', () => {
        searchBox.setBounds(this.map.getBounds())
      })

      store.dispatch('mapState/setMap', this.map)

      MapHelpers.setMapCenterBaseOnCountryId()

      searchBox.addListener('places_changed', () => {
        const places = searchBox.getPlaces()

        if (places.length === 0) {
          return
        }

        // For each place, get the icon, name and location.
        const bounds = new google.maps.LatLngBounds()
        places.forEach(place => {
          if (!place.geometry || !place.geometry.location) {
            return
          }

          this.geocodeLatLng(
            place.geometry.location.lat(),
            place.geometry.location.lng()
          )

          this.$store.commit(
            'pointOfInterest/setPointOfInterestGeoCoordinates',
            {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng()
            }
          )

          input.value = place.formatted_address || place.name

          this.marker.setPosition(place.geometry.location)
          this.marker.setVisible(true)

          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport)
          } else {
            bounds.extend(place.geometry.location)
          }
        })
        this.map.fitBounds(bounds)
      })
    },
    clearAddress(address) {
      const hexRegex = /^[A-Z0-9]+\+\w+(?:\s|,|$)/
      const postalCodeRegex = /,\s?[A-Z]?\d{4}[A-Z]{0,3}(?:\s|,|$)/g

      if (hexRegex.test(address)) {
        let cleanedAddress = address.replace(hexRegex, '').trim()
        cleanedAddress = cleanedAddress.replace(postalCodeRegex, ',').trim()
        return cleanedAddress.length > 0 ? cleanedAddress : 'Referencia no disponible'
      }

      return address.replace(postalCodeRegex, ',').trim()
    },
    geocodeLatLng(lat, lng) {
      const latlng = { lat, lng }
      this.geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            const input = document.getElementById('idLugaresAdministracionDireccion')
            let formattedAddress = this.clearAddress(results[0].formatted_address)
            input.value = formattedAddress
            
            this.$store.commit('pointOfInterest/setGeocodeResult', {
              geocodeResult: formattedAddress
            })
          }
        }
      })
    },
    hideMarker() {
      if (this.marker) {
        this.marker.setVisible(false)
      }
    },
    updateCustomMarker({ position, icon, name, color }) {
      const bounds = new google.maps.LatLngBounds()
      if (this.marker) {
        this.marker.setMap(null)
        this.marker = null
      }

      const iconUrl = `https://cdn.jsdelivr.net/npm/@mdi/svg/svg/${icon?.replace('mdi-', '')}.svg`
      const map = this.map
      const marker = new google.maps.Marker({
        position,
        map,
        icon: {
          url: iconUrl,
          scaledSize: new google.maps.Size(26, 26),
          labelOrigin: new google.maps.Point(13, 35)
        },
        label: {
          text: name,
          color: color,
          fontSize: '14px'
        }
      })

      bounds.extend(position)
      store.dispatch('savePointsOnMap', { pointOnMap: marker })

      if (!bounds.isEmpty()) {
        map.fitBounds(bounds)
        map.panToBounds(bounds)
        if (map.getZoom() > 14) {
          map.setZoom(14)
        }
      }

      this.geocoder.geocode({ location: position }, (results, status) => {
        if (status === 'OK' && results[0]) {
          const formattedAddress = this.clearAddress(results[0].formatted_address)
          this.$root.$emit('location-updated', formattedAddress)
        }
      })
    }
  }
}
</script>

<style>
.google-map {
  width: 100%;
  min-height: 100%;
}

#pac-container {
  padding-bottom: 12px;
  margin-right: 12px;
}

.controls {
  display: inline-block;
  padding: 5px 11px;
}

.controls label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}

#idLugaresAdministracionDireccion {
  background-color: #fff;
  font-family: 'Lato';
  font-size: 16px;
  font-weight: 500;
  color: var(--flat-blue-dark);
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 60%;
  max-width: 400px;
  position: absolute;
  display: flex;
  margin-top: 16px;
  height: 45px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  border: 1px solid #979797;
}

input:focus {
  outline: 0;
}
</style>
